import { render } from "./IconMediaflowLockedPlaceholderImage.vue?vue&type=template&id=878c98b6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMediaflowLockedPlaceholderImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "878c98b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('878c98b6', __exports__)) {
    api.reload('878c98b6', __exports__)
  }
  
  module.hot.accept("./IconMediaflowLockedPlaceholderImage.vue?vue&type=template&id=878c98b6", () => {
    api.rerender('878c98b6', render)
  })

}


export default __exports__